import React from 'react'

import { ColumnProps } from 'antd/lib/table'

import { BalanceDetail } from 'core/application/adminDashboard/reimbursements/reimbursementsBalances/getBalanceDetails'

import { parseZoneFormat } from 'common/dateFormatters'
import { formatMoney } from 'common/moneyFormatter'

const BalanceDetailsColumns = (translate: (key: string) => string): ColumnProps<BalanceDetail>[] => {
  const columns: ColumnProps<BalanceDetail>[] = [
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-balances.date'),
      dataIndex: 'date',
      key: 'date',
      align: 'left',
      sorter: false,
      sortDirections: ['descend', 'ascend'],
      render: (item: string) => {
        return parseZoneFormat(item)
      },
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-balances.allowance'),
      dataIndex: 'allowance',
      key: 'allowance',
      align: 'right',
      render: (item: number) => {
        return item > 0 ? formatMoney(item) : ''
      },
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-balances.reimbursement'),
      dataIndex: 'reimbursement',
      key: 'reimbursement',
      align: 'right',
      render: (item: number) => {
        return item > 0 ? formatMoney(item) : ''
      },
    },
  ]

  return columns
}

export default BalanceDetailsColumns
